import React, { useState } from 'react';
import Reveal from './Reveal';

const SERVICES = [
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Custom Software Development',
    desc: 'Full-stack enterprise solutions with Java, Python, JS/TS, and PHP — scalable, secure, and built to last.',
    techs: ['Java', 'Python', 'TypeScript', 'PHP'],
    accent: 'brand-blue',
    gradient: 'from-brand-blue/20 to-brand-cyan/10',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'AI Development & Integration',
    desc: 'Advanced AI: chatbots, agents, predictive models, generative AI, and NLP systems that transform operations.',
    techs: ['Machine Learning', 'NLP', 'Computer Vision', 'Gen AI'],
    accent: 'brand-purple',
    gradient: 'from-brand-purple/20 to-brand-violet/10',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Mobile App Development',
    desc: 'Native and cross-platform iOS & Android apps with modern frameworks, exceptional UX, and blazing performance.',
    techs: ['React Native', 'Flutter', 'iOS', 'Android'],
    accent: 'brand-cyan',
    gradient: 'from-brand-cyan/20 to-brand-blue/10',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9" />
      </svg>
    ),
    title: 'Web Development & SaaS',
    desc: 'Corporate sites, web portals, and multi-tenant SaaS platforms engineered for scale and user delight.',
    techs: ['React', 'Node.js', 'SaaS Arch', 'Cloud'],
    accent: 'brand-green',
    gradient: 'from-brand-green/20 to-brand-cyan/10',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0" />
      </svg>
    ),
    title: 'Freelancing & Outsourcing',
    desc: 'Flexible engagement models — team augmentation, dedicated devs, or full project ownership for startups & enterprises.',
    techs: ['Team Augmentation', 'Agile', 'Project Mgmt'],
    accent: 'brand-gold',
    gradient: 'from-brand-gold/20 to-brand-pink/10',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    ),
    title: 'Skill Development Training',
    desc: 'Corporate and individual training in AI/ML, full-stack development, and modern tech frameworks.',
    techs: ['AI/ML Workshops', 'Corporate Training', 'Bootcamps'],
    accent: 'brand-pink',
    gradient: 'from-brand-pink/20 to-brand-purple/10',
  },
];

const Services = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="services" className="section-padding bg-brand-bg relative overflow-hidden scroll-mt-16">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="absolute top-1/3 right-0 w-96 h-96 rounded-full bg-brand-blue/5 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <Reveal from="up" className="section-header">
          <div className="inline-flex items-center gap-2 glass px-4 py-2 rounded-full text-sm font-medium text-brand-purple border border-brand-purple/20 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-purple" />
            What We Do
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-brand-text mb-5">
            Our <span className="text-gradient">Services</span>
          </h2>
          <p className="text-lg text-brand-muted max-w-2xl mx-auto">
            Comprehensive technology solutions that drive innovation, efficiency, and measurable growth for businesses of all sizes.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((svc, i) => (
            <Reveal key={i} from="up" delay={i * 70}>
              <div
                className={`relative card group cursor-default h-full transition-all duration-300 overflow-hidden ${hovered === i ? 'shadow-glow-blue border-brand-blue/30' : ''}`}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
              >
                {/* Gradient bg on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${svc.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl`} />

                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-5 bg-${svc.accent}/15 text-${svc.accent} group-hover:scale-110 transition-transform duration-300`}>
                    {svc.icon}
                  </div>

                  <h3 className="text-brand-text font-bold text-lg mb-3 group-hover:text-brand-blue transition-colors duration-200">
                    {svc.title}
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed mb-5">{svc.desc}</p>

                  {/* Tech tags */}
                  <div className="flex flex-wrap gap-2">
                    {svc.techs.map((t, ti) => (
                      <span key={ti} className={`text-xs font-semibold px-2.5 py-1 rounded-full bg-${svc.accent}/10 text-${svc.accent} border border-${svc.accent}/20`}>
                        {t}
                      </span>
                    ))}
                  </div>

                  {/* Bottom line */}
                  <div className={`mt-5 h-0.5 w-0 bg-gradient-to-r from-${svc.accent} to-brand-purple rounded-full group-hover:w-full transition-all duration-500`} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Bottom CTA */}
        <Reveal from="up" delay={200}>
          <div className="mt-16 glass rounded-2xl p-8 md:p-10 border border-brand-border text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-text mb-3">
              Ready to build something extraordinary?
            </h3>
            <p className="text-brand-muted mb-7 max-w-xl mx-auto">
              Let's discuss how our expertise can transform your business with cutting-edge technology solutions tailored just for you.
            </p>
            <button
              onClick={() => { const el = document.querySelector('#contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
              className="btn-primary px-8 py-4 text-base"
            >
              Start Your Project
              <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Services;
